"use client";
import React from "react";

export default function AboutSection() {
  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gy-4">
          <div className="col-lg-6 order-1 order-lg-2">
            <img
              src="/assets/img/about-us.jpg"
              className="img-fluid"
              alt="About"
            />
          </div>
          <div className="col-lg-6 order-2 order-lg-1 content">
            <h3>About Us</h3>
            <p>
              SMART SERVICE is a Mehsana-based manpower and labor supply firm
              established in July 2024 by partners
              <b> Mr. Rohitkumar Chaudhari </b>and<b>  Mrs. Jayanaben Chaudhari.</b>
            </p>
            <p>
              We provide skilled, semi-skilled, and unskilled manpower for
              government and private projects across India, covering sectors
              like construction, housekeeping, security, technical staffing, and
              facility management. As a registered firm, we ensure
              professionalism and full compliance.
            </p>
            <p>
              At <b>SMART SERVICE</b>, we aim to build lasting client relationships by
              delivering timely and reliable manpower. Backed by local strength
              and a national vision, we serve your workforce needs with
              integrity and efficiency.
            </p>
            <h5>Vision & Mission </h5>
            <ul>
              <li>
                <i className="bi bi-check2-all"></i>{" "}
                <span>Win and manage large-scale tenders</span>
              </li>
              <li>
                <i className="bi bi-check2-all"></i>{" "}
                <span>
                  Supply skilled, semi-skilled and unskilled workforce—with
                  stringent compliance
                </span>
              </li>
              <li>
                <i className="bi bi-check2-all"></i>{" "}
                <span>
                  Offer turnkey manpower support: recruitment, training,
                  mobilization, deployment and support
                </span>
              </li>             
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
